// @flow

import React, { useEffect, useState } from 'react'
import Dropdown from 'michelangelo/dist/WebComponents/Inputs/AnalyticsDropdown'
import SearchBar from 'michelangelo/dist/WebComponents/Inputs/AnalyticsSearchBar'
import ContentIcon from '../Shared/Icons/icon-content.svg'
import UserIcon from '../Shared/Icons/icon-user.svg'
import { fetchSearchResults } from '../Redux/Actions/Search'
import { useDispatch, useSelector } from 'react-redux'
import { fetchGroups, fetchProfiles } from '../Redux/Actions/FilterLists'
import AwesomeDebouncePromise from 'awesome-debounce-promise'
import { useNavigate } from 'react-router'
import { componentCreated } from '../Redux/Actions/DateFilter'
import { processGroup } from '../utils/analytics-utils'

function Search () {
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const groupFilter = useSelector(state => state.filterSources)
  const id = useSelector(state => state.account.ID)
  const users = useSelector(state => state.search.users)
  const contents = useSelector(state => state.search.contents)
  const searchType = useSelector(state => state.search.searchType)
  const profiles = useSelector(state => state.filterSources.profiles)
  const userAnalyticsEnabled = useSelector(state => state.account.userAnalyticsEnabled)
  const name = 'Search'

  const searchAPIDebounced = AwesomeDebouncePromise((searchTerm) => update(null, searchTerm), 500)
  const dropDownList = userAnalyticsEnabled ? [[ContentIcon, 'Content Title'], [UserIcon, 'User Name'], [UserIcon, 'User Email']] : [[ContentIcon, 'Content Title']]

  const [searchTerm, setSearchTerm] = useState('')
  const [dropdownSelected, setDropdownSelected] = useState(dropDownList[0[1]])

  useEffect(() => {
    dispatch(componentCreated(name))
  }, [])

  useEffect(() => {
    if (profiles.length < 1 || profiles[0]._id === '0') {
      dispatch(fetchProfiles(id, {}))
      dispatch(fetchGroups(id, {}))
    }
  }, [])

  useEffect(() => {
    setDropdownSelected(dropDownList[0][1])
  }, [])

  const onDropDownChange = (selectedValue) => {
    setDropdownSelected(selectedValue)
    update(selectedValue)
  }

  const onSearchItemClick = (item: Object) => {
    const pathType = searchType === 'CONTENT' ? 'content' : 'admindetails'
    const path = '/' + pathType + '?id=' + item._id + '&date=Week&filter=__'
    navigate(path)
  }

  const onSearchChange = async (searchTerm) => {
    setSearchTerm(searchTerm)
    await searchAPIDebounced(searchTerm)
  }

  const update = (dropdownSelection, searchTerm, newID) => {
    const ID = newID || id
    const dropdown = dropdownSelection || dropdownSelected
    const search = searchTerm || searchTerm
    const group = processGroup(groupFilter)
    if (search !== '') {
      dispatch(fetchSearchResults(ID, dropdown, search, { group: group.groups, profile: group.profiles, limit: 20, offset: 0 }))
    }
  }

  const list = searchType === 'CONTENT' ? contents : users
  return (
    <div id='searchBar'>
      <div style={{ float: 'left' }}>
        <Dropdown list={dropDownList} onListItemClick={onDropDownChange} />
      </div>
      <div style={{ float: 'left' }}>
        <SearchBar list={searchTerm ? list : []} onChange={onSearchChange} placeholder='Search here ...' onListItemClick={onSearchItemClick} />
      </div>
    </div>
  )
}

export default Search
